import { AnimatePresence, motion } from "framer-motion"
import { useState } from "react"
import { FaMinus, FaPlus } from "react-icons/fa6"
import { Button } from "../../myne/Button/Button"

const faqs = [
  {
    id: 1,
    question: "How is Premagic different from other tools in this space?",
    answer:
      "Most event tools solve operational problems like registration and check-in. Premagic is an event marketing platform — it runs pre-event, during-event, and post-event campaigns that turn your attendees into organic advocates, driving measurable reach, registrations, and ROI without ad spend.",
  },
  {
    id: 2,
    question: "How is Premagic priced?",
    answer:
      "Premagic offers flexible pricing depending on event size and features required.",
  },
  {
    id: 3,
    question: "Do you offer support?",
    answer:
      "Yes. Our team provides onboarding support and customer success guidance.",
  },
  {
    id: 4,
    question: "Does Premagic integrate with event tools?",
    answer:
      "Yes, Premagic integrates seamlessly with leading event platforms and CRMs.",
  },
  {
    id: 5,
    question: "Can I customize the branding?",
    answer:
      "Absolutely. You can white-label the entire experience to match your event brand.",
  },
  {
    id: 6,
    question: "Is there a limit on the number of attendees?",
    answer:
      "No, our infrastructure is built to scale from small webinars to massive stadium events.",
  },
]

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState(null)
  const [isExpanded, setIsExpanded] = useState(false)

  const initialItems = 4
  const displayedFaqs = isExpanded ? faqs : faqs.slice(0, initialItems)

  return (
    <section className="pt-0 pb-10 md:pb-20 overflow-hidden">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-[34px] md:text-6xl font-semibold md:text-center text-gray-900 mb-10 md:mb-20">
          Frequently Asked Questions
        </h2>

        <motion.div
          layout
          transition={{ duration: 0.5, ease: [0.4, 0, 0.2, 1] }}
          className="space-y-2"
        >
          <AnimatePresence mode="popLayout" initial={false}>
            {displayedFaqs.map((faq, index) => {
              const isOpen = openIndex === index
              return (
                <motion.div
                  key={faq.id}
                  layout
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: "auto" }}
                  exit={{ opacity: 0, height: 0 }}
                  transition={{ duration: 0.4, ease: "easeInOut" }}
                  className="border-b border-gray-200 overflow-hidden cursor-pointer !select-none"
                >
                  <div
                    onClick={() => setOpenIndex(isOpen ? null : index)}
                    className="flex items-center justify-between w-full py-6 text-left"
                  >
                    <h3
                      className={`text-base md:text-xl font-semibold transition-colors ${
                        isOpen ? "text-indigo-600" : "text-black"
                      }`}
                    >
                      {faq.question}
                    </h3>
                    <div className="ml-4">
                      {isOpen ? <FaMinus /> : <FaPlus />}
                    </div>
                  </div>

                  <AnimatePresence>
                    {isOpen && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.3 }}
                      >
                        <p className="text-base md:text-md pb-6 text-gray-600 leading-relaxed pr-10">
                          {faq.answer}
                        </p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </motion.div>
              )
            })}
          </AnimatePresence>
        </motion.div>

        {!isExpanded && (
          <motion.div layout className="mt-12 text-center">
            <Button
              onClick={() => {
                setIsExpanded(!isExpanded)
                setOpenIndex(null)
              }}
              variant="tertiary"
              className="!p-0"
              hideIcon
            >
              {isExpanded ? "Show Less" : "Show More"}
            </Button>
          </motion.div>
        )}
      </div>
    </section>
  )
}
